/**
 * Shared validator for slot capacity × slot count vs hard cap.
 * Used in both Add Date and Edit Date modals.
 */
export function validateSlotCapacityVsHardCap({ capacityPerSlot, hardCap, slotCount }) {
  const cap = Number(capacityPerSlot || 0);
  const hc = hardCap === "" || hardCap == null ? null : Number(hardCap);
  const n = Number(slotCount || 0);
  if (hc == null || n === 0 || cap === 0) {
    return { hasConflict: false, total: cap * n, hardCap: hc, slotCount: n, suggestedPerSlot: cap, remainder: 0 };
  }
  const total = cap * n;
  if (total <= hc) {
    return { hasConflict: false, total, hardCap: hc, slotCount: n, suggestedPerSlot: cap, remainder: 0 };
  }
  const suggested = Math.floor(hc / n);
  const remainder = hc - suggested * n;
  return { hasConflict: true, total, hardCap: hc, slotCount: n, suggestedPerSlot: suggested, remainder };
}
